$(document).ready(function() {
  // Toggle dropdown
  $('.dyc-bold-selected-item').click(function() {
    $(this).parents('.product-additional-attr').siblings().find('.dyc-bold-options').hide(); // 隐藏其他下拉框
    $(this).siblings('.dyc-bold-options').toggle();
  });

  // Select an option
  $('.dyc-bold-options li').click(function() {
    var selectedImg = $(this).data('img');
    var selectedValue = $(this).data('value');
    var selectedText = $(this).data('text');
    
    $(this).parents('.dyc-bold-dropdown').siblings('.sw_attr_helper').val(selectedValue);
    $(this).parents('.dyc-bold-dropdown').siblings('.sw_attr_helper_img').val(selectedImg);

    // Update selected item
    $(this).parents('.dyc-bold-dropdown').find('.dyc-bold-selected-img').attr('src', selectedImg);
    $(this).parents('.dyc-bold-dropdown').find('.dyc-bold-selected-text').text(selectedText);

    // Close dropdown
    $(this).parents('.dyc-bold-options').hide();
  });

  // Close dropdown when clicking outside
  $(document).click(function(event) {
    if (!$(event.target).closest('.dyc-bold-dropdown').length) {
      $('.dyc-bold-options').hide();
    }
  });

  // Prevent dropdown from closing when clicking inside
  $('.dyc-bold-dropdown').click(function(event) {
    event.stopPropagation();
  });
});
// // 在事件总线上监听事件 - 重置vip默认勾选
// dycEventBus.on('dycAccessoriesResetDefault', function(data) {
//   // console.log('事件触发了！数据是：', data);
//   $('.dyc-bold-dropdown').each(function(){
//     $(this).find('.dyc-bold-options ul li:last').click();
//   });
// });